import React from "react";
import { makeStyles } from "@material-ui/styles";
import { formatInternalCode } from "../../functions/cart/cartLine";

const useStyles = makeStyles(() => ({
  root: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "0.75rem",
    margin: 0,
    textAlign: "left",
  },
}));

// カート行・お気に入り行に出す社内品番。
// 商品名・サイズ・価格がすべて同じ別商品(396と398など)を見分けるために表示する。
const InternalCodeLabel = ({ idin }) => {
  const classes = useStyles();
  const label = formatInternalCode(idin);
  return label ? <p className={classes.root}>{label}</p> : null;
};

export default InternalCodeLabel;
